"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLoginAvailabilityResponseDto = instanceOfLoginAvailabilityResponseDto;
exports.LoginAvailabilityResponseDtoFromJSON = LoginAvailabilityResponseDtoFromJSON;
exports.LoginAvailabilityResponseDtoFromJSONTyped = LoginAvailabilityResponseDtoFromJSONTyped;
exports.LoginAvailabilityResponseDtoToJSON = LoginAvailabilityResponseDtoToJSON;
exports.LoginAvailabilityResponseDtoToJSONTyped = LoginAvailabilityResponseDtoToJSONTyped;
/**
 * Check if a given object implements the LoginAvailabilityResponseDto interface.
 */
function instanceOfLoginAvailabilityResponseDto(value) {
    if (!('accountExists' in value) || value['accountExists'] === undefined)
        return false;
    return true;
}
function LoginAvailabilityResponseDtoFromJSON(json) {
    return LoginAvailabilityResponseDtoFromJSONTyped(json, false);
}
function LoginAvailabilityResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accountExists': json['accountExists'],
    };
}
function LoginAvailabilityResponseDtoToJSON(json) {
    return LoginAvailabilityResponseDtoToJSONTyped(json, false);
}
function LoginAvailabilityResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'accountExists': value['accountExists'],
    };
}
